import { Controller } from "@hotwired/stimulus"

/**
 * Inline Edit Controller
 *
 * Toggles visibility of inline edit forms within table rows.
 * Used for editing risk area vehicles without leaving the page.
 *
 * @example
 * <tr data-controller="inline-edit">
 *   <td>Content...</td>
 *   <td>
 *     <button data-action="click->inline-edit#toggle">Edit</button>
 *     <div class="hidden" data-inline-edit-target="form">
 *       <form>...</form>
 *     </div>
 *   </td>
 * </tr>
 */
export default class extends Controller {
  static targets = ["form", "display"]

  static classes = ["hidden"]

  connect() {
    // Ensure form starts hidden
    if (this.hasFormTarget) {
      this.formTarget.classList.add("hidden")
    }
  }

  /**
   * Toggle the edit form visibility
   */
  toggle(event) {
    event?.preventDefault()

    if (this.hasFormTarget) {
      this.formTarget.classList.toggle("hidden")
    }

    if (this.hasDisplayTarget) {
      this.displayTarget.classList.toggle("hidden")
    }
  }

  /**
   * Show the edit form
   */
  show(event) {
    event?.preventDefault()

    if (this.hasFormTarget) {
      this.formTarget.classList.remove("hidden")
    }

    if (this.hasDisplayTarget) {
      this.displayTarget.classList.add("hidden")
    }

    // Focus first input in form
    const firstInput = this.formTarget?.querySelector("input, select, textarea")
    if (firstInput) {
      firstInput.focus()
    }
  }

  /**
   * Hide the edit form
   */
  hide(event) {
    event?.preventDefault()

    if (this.hasFormTarget) {
      this.formTarget.classList.add("hidden")
    }

    if (this.hasDisplayTarget) {
      this.displayTarget.classList.remove("hidden")
    }
  }

  /**
   * Handle escape key to close form
   */
  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.hide()
    }
  }
}
